import { useState } from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  TextField,
  Typography
} from '@mui/material'
import css from './DatosUuid.module.css'

const DatosUuid = ({ accesoAlumno }) => {
  const [isExpanded, setExpanded] = useState(true)

  const handleChange = (_event, isExpanded) => setExpanded(isExpanded)

  return (
    <Accordion expanded={isExpanded} onChange={handleChange}>
      <AccordionSummary
        expandIcon={<i className='material-icons'>expand_more</i>}
      >
        <div className={css.label}>
          <Typography className={css.title} variant='h2'>
            Classfy UUID
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <div className={css.info}>
          <TextField
            label='Classfy UUID'
            value={accesoAlumno.uuid || ''}
            variant='standard'
          />
        </div>
      </AccordionDetails>
    </Accordion>
  )
}

export default DatosUuid
